// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6f1c45c1","316":"416c1f01","471":"b2017446","502":"8bd65b29","643":"25b9c713","787":"c4731be9"}[chunkId] + ".chunk.js";
};